import { render, staticRenderFns } from "./BaseSideMenu.vue?vue&type=template&id=26b818a8&"
import script from "./BaseSideMenu.vue?vue&type=script&lang=js&"
export * from "./BaseSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports